var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBulkFrontIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 12,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000093",
    d: "M1.473.86a.664.664 0 1 0-.94.94l4.193 4.193-4.193 4.194a.664.664 0 0 0 .473 1.133c.174 0 .34-.067.474-.193L6.146 6.46c.26-.26.26-.68 0-.94L1.473.86Zm6.86-.193c-.367 0-.667.3-.667.666v9.334c0 .366.3.666.667.666.367 0 .667-.3.667-.666V1.333c0-.366-.3-.666-.667-.666Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkFrontIcon);
export default __webpack_public_path__ + "static/media/bulkFrontIcon.7bf148f6e25386d28ce78f83fa2129e8.svg";
export { ForwardRef as ReactComponent };